import { Location, LocationStrategy } from '@angular/common';
import { Directive } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IDictionaryQuery } from '../interfaces/models/idictionary-query.model';
import { IDictionary } from '../interfaces/models/idictionary.model';
import { EntityState } from '../models/enums';
import { DictionaryBaseService } from '../services/dictionary-base.service';
import { EventsService } from '../services/events.service';
import { UserContextService } from '../services/user-context.service';
import { ModelListBaseComponent } from './model-list-base.component';

@Directive({
    selector: 'demo',
    standalone: false
})

export abstract class DictionaryListBaseComponent
  <T extends IDictionary, TQuery extends IDictionaryQuery> extends ModelListBaseComponent<number, T> {

  newItemFakeId: number = 0;

  constructor(
    protected events: EventsService,
    protected modelSvc: DictionaryBaseService<T>,
    protected userContextSvc: UserContextService,
    protected router: Router,
    protected route: ActivatedRoute,
    protected location: Location,
    protected locationStrategy: LocationStrategy) {

    super(events, modelSvc, userContextSvc, router, route, location, locationStrategy);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  protected createNewEntity(): T {
    return { Id: this.newItemFakeId--, State: EntityState.New } as T;
  }

  addNewRow() {
    this.entities.unshift(this.createNewEntity());
    this.tableTotalRows++;
  }

  preSaveRow(model: T) : boolean {
    let validation = this.modelSvc.validate(model);
    if (!validation.Valid) {
      this.showWarningMessage('Сохранение', validation.Message);
      return false;
    }
    return true;
  }

  saveRow(model: T) : void {
    if (this.loading)    
      return;    
    if(!this.preSaveRow(model))
      return;
    this.loading = true;
    this.modelSvc.save([model]).toPromise()
      .then(x => {        
        model.Id = x[0].Id;
        model.State = EntityState.View;
      })      
      .catch((err) => {
        this.loading = false;
        this.showExceptionMessage('Сохранение', err);
      })
      .finally(() => this.loading = false);
  }

  deleteRow(model: T) : void {
    if (this.loading)
      return;
    if (model.State != EntityState.New) {
      this.loading = true;
      this.modelSvc.delete([model]).toPromise()
        .then(x => {
          this.removeFromCurrentItems(model);
        })        
        .catch((err) => {
          this.loading = false;
          this.showExceptionMessage('Удаление', err);
        })
        .finally(() => this.loading = false);
    }
    else {
      this.removeFromCurrentItems(model);
      this.tableTotalRows--;
    }
  }

  loadPaged(query: TQuery) {
    query.Ids = null;
    if(query.Id){
      query.Ids = [query.Id]
    }
    this.loading = true;
    this.modelSvc.fetchPaged(query).toPromise()
      .then(x => {
        this.entities = x.Items;
        this.tableTotalRows = x.TotalCount;
      })
      .then(x => this.loading = false)
      .catch((err) => {
        this.loading = false;
        this.showExceptionMessage('Загрузка', err);
      });
  }
}
